import {Route, Routes} from 'react-router-dom'
import {Businesses} from 'modules/business/Businesses'
import {Business} from 'modules/business/Business'
import {DeviceTypes} from 'utility/utility'
import {Device} from 'modules/device/Device'
import { Group } from 'modules/group/Group'

export const BusinessRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Businesses />} />
      <Route path="/create" element={<Business />} />
      <Route path="/:business" element={<Business />} />
      <Route path="/:business/group/:group" element={<Group />} />
      <Route path={`/:business/${DeviceTypes.OFFICE}/create`} element={<Device office />} />
      <Route path={`/:business/${DeviceTypes.OFFICE}/update/:device`} element={<Device office update />} />
      <Route path={`/:business/${DeviceTypes.REMOTE}/create/:user`} element={<Device />} />
      <Route path={`/:business/${DeviceTypes.REMOTE}/update/:user/:device`} element={<Device update />} />
    </Routes>
  )
}
